export const flowSignUpZH = {
  flowSignUp1: '提交报名资料',
  flowSignUp2: '编辑报名资料',
  flowSignUp3: '请认真填写报名资料，将用于本次活动期间的认证、通知、酒店、证书制作等环节。',
  flowSignUp4: '所填报名信息将用于本次活动的认证、通知、酒店、证书制作等环节',
  flowSignUp5: '在',
  flowSignUp6: '之后将不再支持修改报名资料',
  flowSignUp7: '请选择地区',
  flowSignUp8: '(请以身份证的真实姓名为准)',
  flowSignUp9: '(请以护照姓为准，如无，请按照身份证件姓名的拼音姓填写)',
  flowSignUp10: '例',
  flowSignUp11: '(请以身份证号的出生日期为准)',
  flowSignUp12: '选择日期',
  flowSignUp13: '(提交后不可再修改，请认真选择&填写)',
  flowSignUp14: '(不可修改)',
  flowSignUp15: '区号',
  flowSignUp16: '请填写手机号',
  flowSignUp17: '请填写电子邮箱',
  flowSignUp18: '请填写证件号',
  flowSignUp19: '请选择年级',
  flowSignUp20: '提交',
  flowSignUp21: '缴费后才可参与活动哦~',
  flowSignUp22: '报名成功',
  flowSignUp23: '立即缴费',
  flowSignUp24: '请确保填写的报名资料准确，此信息将用于后续学术活动环节',
  flowSignUp25: '确定提交报名资料吗？',
  flowSignUp26: '请按规范填写拼音“姓，拼音”',
  flowSignUp27: '请按规范填写拼音“名，拼音”',
  flowSignUp28: '请输入姓名',
  flowSignUp29: '请选择学校！',
  flowSignUp30: '填写拼音姓！',
  flowSignUp31: '填写拼音名！',
  flowSignUp32: '请填写中文名！',
  flowSignUp33: '请选择性别！',
  flowSignUp34: '请选择生日！',
  flowSignUp35: '请选择证件类型',
  flowSignUp36: '请填写证件号！',
  flowSignUp37: '请填写手机号！',
  flowSignUp38: '请填写邮箱号！',
  flowSignUp39: '请选择年级！',
  flowSignUp40: '请按规范填写姓名拼音',
  flowSignUp41: '请选择组别任务的名称',
  flowSignUp42: '修改成功',
  flowSignUp43: '缴费任务未配置',
  flowSignUp44: '请输入或选择学校',
  flowSignUp45: '请认真填写报名资料，将用于本次活动期间的认证、通知、酒店、证书制作。地区、手机、证件提交后不再支持修改。',
  flowSignUp46: '所填信息将用于本次活动的认证、通知、酒店、证书制作，地区、手机、证件不支持修改',
  flowSignUp47: '所填信息将用于本次活动的认证、通知、酒店、证书制作，地区、手机、证件不支持修改，Y年M月D日之后将不再支持修改报名资料。',
  flowSignUp48: '请输入手机号，提交后不可修改',
  flowSignUp49: '请选择出生日期',
  flowSignUp50: '当前就读学校',
  flowSignUp51: '当前就读年级',
  flowSignUp52: '备注',
  flowSignUp53: '提交申请',
  flowSignUp54: '报名成功，请前往缴费',
  flowSignUp55: '按区域查找学校',
  flowSignUp56: '请选择省',
  flowSignUp57: '请选择市',
  flowSignUp58: '请选择学校',
  flowSignUp59: '输入学校关键字',
  flowSignUp60: '选择区号',
  flowSignUp61: '修改姓名',
  flowSignUp62: '常用邮箱',
  flowSignUp63: '请输入证件号',
  flowSignUp64: '选择证件类型',
  flowSignUp65: '选择年级',
  flowSignUp66: '选择地区',
  flowSignUp67: '选择任务组别',
  flowSignUp68: '选择拼音名',
  flowSignUp69: '选择性别',
  flowSignUp70: '请选择性别',
  flowSignUp71: '邮箱',
  flowSignUp72: '(请以护照名为准，如无，请按照身份证件姓名的拼音名填写)',
  flowSignUp73: '(姓名请以身份证的真实姓名为准，拼音姓、名请以护照为准，如无，请按照身份证件姓名的拼音名填写)',
  flowSignUp74: '基本信息',
  flowSignUp75: '学校信息',
  flowSignUp76: '联系方式',
  flowSignUp77: '报名截止',
  flowSignUp78: '上传证件照',
  flowSignUp79: '请认真填写报名资料，将用于本次活动期间的认证、通知、酒店、证书制作等环节。',
  flowSignUp80: '上传证件照',
  flowSignUp81: '请选择要上传的证件类型',
  flowSignUp82: '缴费后才可以参与活动哦~',
  flowSignUp83: '确定',
  flowSignUp84: '取消',
  flowSignUp85: '立即缴费',
  flowSignUp86: '上传成功',
  flowSignUp87: '上传中请稍等',
  flowSignUp88: '参考示例：初一（2）班、G10-2',
  flowSignUp89: '（为更好地管理班级，相同班级请填写统一的班级名称）',
  flowSignUp90: '队友之间可查看联系方式',
  flowSignUp91: '完善注册信息',
  flowSignUp92: '确定提交注册信息吗？',
  flowSignUp93: '请确保填写的注册信息准确，此信息将用于后续学术活动环节',
  flowSignUp94: '缴费成功',
  flowSignUp95: '请完善注册信息以便更好地参与后续活动哦~',
  flowSignUp96: '立即完善',
  flowSignUp97: '请认真完善注册信息，将用于本次活动期间的认证、通知、酒店、证书制作等环节。',
  flowSignUp98: '请填写你的真实姓名',
  flowSignUp99: '请填写可与你联系的手机号，提交后不可修改',
  flowSignUp100: '请填写可与你联系的邮箱地址',
  flowSignUp101: '任务指引',
  flowSignUp102: '前往'
 }

export const flowSignUpEN = {
  flowSignUp1: 'Application Materials',
  flowSignUp2: 'Edit the application information',
  flowSignUp3: 'Please fill in the registration materials carefully, which will be used for authentication, notification, hotel, and certificate production during this activity.',
  flowSignUp4: 'The registration information will be used for the authentication, notification, hotel, and certificate production for this activity',
  flowSignUp5: 'The registration information cannot be modified after ',
  flowSignUp6: '',
  flowSignUp7: 'Please select a region',
  flowSignUp8: '(Please refer to the real name of the ID card)',
  flowSignUp9: '(Please refer to the surname of the passport, if not, please fill in the pinyin of surname on your ID card)',
  flowSignUp10: 'Example:',
  flowSignUp11: '(Please refer to the date of birth of the ID number)',
  flowSignUp12: 'Select Date',
  flowSignUp13: '(After submission, it cannot be modified, please carefully select & fill in)',
  flowSignUp14: '(Non-modifiable)',
  flowSignUp15: 'Code',
  flowSignUp16: 'Please fill in phone number',
  flowSignUp17: 'Please fill in email address',
  flowSignUp18: 'Please fill in ID number',
  flowSignUp19: 'Please select a grade',
  flowSignUp20: 'Submit',
  flowSignUp21: 'You can only participate in the activity after paying the fee~',
  flowSignUp22: 'Successful Registration',
  flowSignUp23: 'Pay Now',
  flowSignUp24: 'Please ensure that the registration information filled in is accurate, and this information will be used for subsequent academic activities',
  flowSignUp25: 'Are you sure you want to submit your application materials?',
  flowSignUp26: 'Please fill in the pinyin "surname, pinyin" according to the specification',
  flowSignUp27: 'Please fill in the pinyin "name, pinyin" according to the specification',
  flowSignUp28: 'Please enter your name',
  flowSignUp29: 'Please choose a school!',
  flowSignUp30: 'Fill in the pinyin surname!',
  flowSignUp31: 'Fill in the pinyin name!',
  flowSignUp32: 'Please fill in the Chinese name!',
  flowSignUp33: 'Please select gender!',
  flowSignUp34: 'Please select the date of birth!',
  flowSignUp35: 'Please select the type of ID!',
  flowSignUp36: 'Please fill in ID number!',
  flowSignUp37: 'Please fill in phone number!',
  flowSignUp38: 'Please fill in your email!',
  flowSignUp39: 'Please select a grade!',
  flowSignUp40: 'Please fill in the pinyin of your name according to the specifications',
  flowSignUp41: 'Please select the name of the group task',
  flowSignUp42: 'Modification successful',
  flowSignUp43: 'Payment task is not configured',
  flowSignUp44: 'Please enter or select a school',
  flowSignUp45: 'Please fill in the registration materials carefully, which will be used for authentication, notification, hotel, and certificate production during this activity. Region, mobile phone, and certificate can no longer be modified after submission.',
  flowSignUp46: 'The information will be used for the authentication, notification, hotel and certificate production of this activity. The region, mobile phone and certificate cannot be modified',
  flowSignUp47: 'The information will be used for the authentication, notification, hotel and certificate production of this activity. The modification of region, mobile phone and certificate is not supported. The modification of registration information will not be supported after',
  flowSignUp48: 'Please enter your mobile phone number, it cannot be modified after submission',
  flowSignUp49: 'Please select date of birth',
  flowSignUp50: 'Current school',
  flowSignUp51: 'Current grade',
  flowSignUp52: 'Remarks',
  flowSignUp53: 'Submit application',
  flowSignUp54: 'Successful registration, please pay the fee',
  flowSignUp55: 'Find schools by region',
  flowSignUp56: 'Please select province',
  flowSignUp57: 'Please select city',
  flowSignUp58: 'Please select the school',
  flowSignUp59: 'Enter the school keyword',
  flowSignUp60: 'Select Area Code',
  flowSignUp61: 'Change Name',
  flowSignUp62: 'Frequently Used Email',
  flowSignUp63: 'Please fill in the ID number ',
  flowSignUp64: 'Select ID type',
  flowSignUp65: 'Select Grade',
  flowSignUp66: 'Select District',
  flowSignUp67: 'Select Task Group',
  flowSignUp68: 'Select Pinyin Name',
  flowSignUp69: 'Select gender:',
  flowSignUp70: 'Please select gender',
  flowSignUp71: 'Email',
  flowSignUp72: '(Please refer to your passport name, if not, please fill in the pinyin name of your identity document name.)',
  flowSignUp73: '(Passport/ID card shall prevail)',
  flowSignUp74: 'Basic Information',
  flowSignUp75: 'School Information',
  flowSignUp76: 'contact information',
  flowSignUp77: 'Registration deadline',
  flowSignUp78: 'Select Document Type',
  flowSignUp79: 'Please fill in the registration information carefully, which will be used for authentication, notification, hotel, certificate production, and other activities during this event.',
  flowSignUp80: 'Upload',
  flowSignUp81: 'Please select type of document to upload',
  flowSignUp82: 'You can only participate in the activity after paying the fee~',
  flowSignUp83: 'confirm',
  flowSignUp84: 'cancel',
  flowSignUp85: 'Pay Now',
  flowSignUp86: 'Upload successful',
  flowSignUp87: 'Uploading, please wait a moment',
  flowSignUp88: 'Reference example: G10-2',
  flowSignUp89: '（For better class management, please fill in the same class name）',
  flowSignUp90: 'Teammates can view each other\'s contact information.',
  flowSignUp91: 'Complete the registration information',
  flowSignUp92: 'Are you sure you want to submit the registration information?',
  flowSignUp93: 'Please ensure that the registration information you filled out is accurate, as this information will be used for subsequent academic activities.',
  flowSignUp94: 'Payment Successful',
  flowSignUp95: 'Please complete your registration information to better participate in subsequent activities.',
  flowSignUp96: 'Complete Now',
  flowSignUp97: 'Please carefully complete the registration information, which will be used for the certification, notification, hotel, certificate production and other processes during this event.',
  flowSignUp98: 'Please fill in your real name',
  flowSignUp99: 'Please enter your contact mobile phone number, it cannot be modified after submission',
  flowSignUp100: 'Please enter your contact email address',
  flowSignUp101: 'Task Guidance',
  flowSignUp102: 'Access'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/signUp.js